import { ManagementLog } from '@lib/hundredBricksAPI/properties/managementLogs';

import NetworkError from '../errors/NetworkError';
import PropertyManagementError from '../errors/PropertyManagement';

import GatewayAPI from './GatewayAPI';

class PropertyManagementAPI extends GatewayAPI {
  // Move this to Hundred Bricks API when endpoint will be modified
  async getLatestLogsPerProperties() {
    try {
      const { data } = await this._client.get('managementLogs/latestByProperty');

      return data.items.map(log => new ManagementLog(log));
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    if (!error.response) {
      throw new NetworkError();
    }

    const { response } = error;
    const { code } = response.data;

    throw new PropertyManagementError(code);
  }
}

export default PropertyManagementAPI;
